<div *ngIf="loading" class="spinner">
  <mat-spinner></mat-spinner>
</div>
<div style="height: 100%;" [ngClass]="loading ? 'content-hidden' : 'content-show'">
  <header class="header">
    <h2 class="card-title">Análise de casos</h2>
    <div class="filter">
      <div class="filter__container">
        <mat-label>Filtrar por: </mat-label>
        <div class="select__wrapper">
          <select
            id="filter-complaints-type"
            (change)="createChart($event.target.value)"
            class="form-control"
            required
          >
            <option value="0">Tipo</option>
            <option value="1">Lugar</option>
            <option value="2">Momento</option>
            <option value="3">Idade</option>
            <option value="4">Gênero</option>
          </select>
        </div>
      </div>
    </div>
  </header>
  <canvas *ngIf="value != 2" id="myHChart"></canvas>
  <div style="height: calc(100% - 50px)" class="container-momento" *ngIf="value == 2">
    <div class="momento-comum content-momento-ocorrido">
      <h3 class="registro">{{momentoOcorrido}}</h3>
      <p class="descricao">Denúncias registradas no momento do ocorrido</p>
    </div>
    <div class="momento-comum content-apos-ocorrido">
      <h3 class="registro">{{momentosPosOcorrido}}</h3>
      <p class="descricao">Denúncias registradas após o ocorrido</p>
    </div>
  </div>
</div>
